<template>
  <div class="map" id="chart-map">
    <layer-switcher-component
      v-if="showLayerSwitcher"
      :activeLayer="activeBaseLayerId"
      :onChange="changeBaseLayer"
      :layers="$conf.chart.layers"
      position="is-bottom-left"
      class="chart-lsw">
    </layer-switcher-component>
    <a href="#"
      v-if="dates.indexOf(date) > 0"
      class="rotate prev"
      @click="e => prevDate(e)">
      <b-icon icon="chevron-left-circle" type="is-black" size="is-large"></b-icon>
    </a>
    <a href="#"
      v-if="dates.indexOf(date) < dates.length - 1"
      class="rotate next"
      @click="e => nextDate(e)">
      <b-icon icon="chevron-right-circle" type="is-black" size="is-large"></b-icon>
    </a>
  </div>
</template>

<script>

import { createStyle } from 'util/layer/StyleBuilder'
import { deepCopy, colorFromArray } from 'util/helpers'
import MapEngine from 'util/MapEngine'
import LayerSwitcherComponent from 'comp/map/LayerSwitcher'

/**
 * App component
 */
export default {
  name: 'ChartImageryComponent',
  components: {
    LayerSwitcherComponent
  },
  props: {
    parcel: {
      type: Object,
      default: null
    },
    date: {
      type: String,
      default: null
    },
    dates: {
      type: Array,
      default: []
    }
  },
  data () {
    return {
      me: null,
      layers: {},
      activeBaseLayerId: Object.keys(this.$conf.chart.layers)[0],
      tileSetLayer: null
    }
  },
  computed: {
    showLayerSwitcher () {
      return Object.keys(this.$conf.chart.layers).length > 1
    }
  },
  mounted () {
    const mapConf = deepCopy(this.$conf.map)
    mapConf.el = '#chart-map'
    mapConf.proj4defs = null
    mapConf.layers = []
    mapConf.interactions = []
    this.me = new MapEngine(mapConf)
    this.layers.base = this.me.createLayer({
      type: 'Group',
      layers: []
    })
    this.layers.overlays = this.me.createLayer({
      type: 'Group',
      layers: []
    })
    Object.keys(this.$conf.chart.layers).forEach(key => {
      this.$conf.chart.layers[key].params.TIME = this.date
    })
    this.createBaseLayers(this.$conf.chart.layers, this.activeBaseLayerId)
    this.createMap()
    this.me.fitTo({
      bbox: this.me.bbox(this.parcel.geometry),
      srid: this.$conf.api.srid || 'EPSG:4326'
    })
    this.tileSetLayer = this.createTileSetLayer(this.$store.getters['tileSetConf'])
    this.me.addLayer(this.tileSetLayer, this.layers.overlays)
  },
  updated () {
    this.layers.base.getLayers().forEach(layer => {
      const params = layer.getSource().getParams()
      params.TIME = this.date
      layer.getSource().updateParams(params)
    })
  },
  methods: {
    createMap () {
      this.me.set({
        layers: Object.keys(this.layers).map(i => this.layers[i])
      })
    },
    createBaseLayers (layers, activeBaseLayerId) {
      Object.keys(layers).forEach(id => {
        layers[id].visible = (id === activeBaseLayerId)
        layers[id].id = id
        layers[id].zIndex = 0
        const layer = this.me.createLayer(layers[id])
        this.me.addLayer(layer, this.layers.base)
      })
    },
    createTileSetLayer (conf) {
      const styleConf = deepCopy(this.$conf.tilesets.style.selected)
      styleConf.stroke.width = 2
      const selectedStyle = createStyle(styleConf)
      const selectedId = this.parcel[this.$conf.search.id]
      const layerConf = {
        type: 'MVT',
        id: conf.id,
        title: 'Tile set',
        projection: 'EPSG:3857',
        url: this.$conf.tilesets.url + this.$conf.tilesets.key + '/' + conf.id + '/{z}/{x}/{y}.' + conf.format,
        extent: this.$map.transform({ bbox: conf.bounds, from: 'EPSG:4326' }),
        style: (feature, resolution, buildStyle) => {
          // selected
          if (feature.get('id') === selectedId) {
            return selectedStyle
          }
          return null
        },
        tileGrid: {
          minZoom: conf.minzoom,
          maxZoom: conf.maxzoom
        }
      }
      return this.me.createLayer(layerConf)
    },
    changeBaseLayer (layerid) {
      this.layers.base.getLayers().forEach(layer => {
        if (layer.get('id') === layerid) {
          layer.setVisible(true)
        } else {
          layer.setVisible(false)
        }
      })
    },
    prevDate (e) {
      e.preventDefault()
      const i = this.dates.indexOf(this.date)
      this.$store.dispatch('chartDate', this.dates[i - 1])
    },
    nextDate (e) {
      e.preventDefault()
      const i = this.dates.indexOf(this.date)
      this.$store.dispatch('chartDate', this.dates[i + 1])
    }
  }
}



</script>

<style lang="stylus">
.chart-lsw
  position: absolute
  top: 10px
  right: 10px
  z-index: 200
.rotate
  position: absolute
  top: 50%
  z-index: 2
  opacity: .8
  &.prev
    left: 20px
  &.next
    right: 20px
</style>
